__turbopack_context__.v({
  "body": "TeamProjectsAddProject-module-scss-module__oX2ira__body",
  "hint": "TeamProjectsAddProject-module-scss-module__oX2ira__hint",
  "link": "TeamProjectsAddProject-module-scss-module__oX2ira__link",
});
